export const MockCreateTrafficDataCOMMAND = "mock-create-traffic-data";
